import React, { useEffect, useState } from "react"; 
import SplashShowcase from "./pages/splashscreens/splashshowcase";
import WelcomeScreen from "./pages/welcome_screen";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, useParams } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import SignIn from "./pages/signin";
import SignUp from "./pages/signup";
import { AuthProvider } from "./contexts/AuthContext";
import { VitalsProvider } from "./contexts/VitalsContext";
import ProfilePage from "./pages/profilepage.jsx";
import ProfileFull from "./pages/ProfileFull";
import Settings from "./pages/settingspage.jsx";
import ForgotPasswordOptions from "./pages/forgetpasswordoptions.jsx";
import ForgotPasswordReset from "./pages/forgetpasswordreset.jsx";
import PasswordResetConfirmation from "./pages/forgetconfirmation.jsx";
import ResetPassword from "./pages/resetpassword.jsx";
import ProfileSetup from "./pages/profile_setup.tsx";
import Home from "./pages/home.jsx";
import SymptomChat from "./pages/symptom-checker.jsx";
import ChatPage from "./pages/ai-chat.jsx";
import HealthJourneyStart from "./pages/health_journey_start.jsx";
import CoverPage from "./pages/chat-cover.jsx";
import NotificationPage from "./pages/notification.jsx";
import ProtectedRoute from "./components/ProtectedRoute";
import api from "./lib/api.js";
import EPharmacy from "./pages/epharmacy.jsx";
import SearchResults from "./pages/search_value.jsx";
import ProductPage from "./pages/productpage.jsx";
import Categories from "./pages/epharmacy-category.jsx";
import CartPage from "./pages/cart.jsx";
import Checkout from "./pages/checkout.jsx";
import OrdersPage from "./pages/order.jsx";
import PrescriptionPage from "./pages/prescription.jsx";
import PharmacySearchPage from "./pages/all_pharmacies.jsx";
import PharmacyDetailPage from "./pages/pharmacyDetail.jsx";
import DoctorDirectory from "./pages/DoctorDirectory.jsx";
import BookingScreen from "./pages/BookingScreen.jsx";
import InPersonBooking from "./pages/InPersonBooking.jsx";
import ClinicDetail from "./pages/ClinicDetail.jsx";
import SupportPage from "./pages/SupportPage.jsx";
import LiveConsultation from "./pages/JoinConsultation.jsx";
import SearchPage from "./components/SearchPage.jsx";
import SpecialistPage from "./components/SpecialistPage.jsx";
import DoctorDetails from "./components/DoctorDetails.jsx";
import AppointmentTimeline from "./components/AppointmentTimeline.jsx";
import RescheduleSlotPage from "./components/reschedule-appoint.jsx";
import CancelAppointmentPage from "./components/CancelAppointment.jsx";
import AppointmentCard from "./components/AppointmentCard.jsx";
import PreCallChecklist from "./components/PreJoinCheck.jsx";
import PatientCallRoom from "./components/ConsultRoom.jsx";
import VideoConsultation from "./pages/VideoConsultation.jsx";
import ConsultationChats from "./pages/ConsultationChats.jsx";
import SharedRecordsViewer from "./pages/SharedRecordsViewer.jsx";
import MockConsultation from "./components/MockConsultation.jsx";
import DoctorCall from "./components/doctor_test.jsx";
import BlogDetail from "./pages/BlogDetail";
import Blogs from "./pages/Blogs";
import { socket } from "./lib/socket.js";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { requestForToken, onMessageListener, consumePendingPushRoute } from "./firebase";
import LabTest from "./pages/LabTest";
import HealthAssistantHero from "./pages/asha.jsx";
import LabTestProfile from "./pages/LabTestProfile.jsx";
import LabCart from "./pages/LabCart.jsx";
import BookingDetails from "./pages/BookinDetails.jsx";
import LabTestSearch from "./pages/LabTestSearch.jsx";
import AllProviders from "./pages/all_providers.jsx";
import ProvidersDetailPage from "./pages/providersDetails.jsx";
import MyHealthRecords from "./pages/MyHealthRecords.jsx";
import WalletTransfer from "./pages/wallet-topup.jsx";
import HealthWalletFullUI from "./pages/Wallet.jsx";
import Scan from "./pages/scan-payment.jsx"
import QrCodeGenerator from "./pages/qrcode.jsx";
import Remote from "./pages/RemoteMonitoring.tsx"
import EmergencyResponseUI from "./pages/QuickResponse.jsx";
import ScanMedicalPage from './pages/scan.jsx';
import NearbyServicesPage from './pages/nearby.jsx';
import CampaignsPage from './pages/campaigns.jsx';
import TrendingDrugs from './pages/trending.jsx';
import FeaturedDrugs from "./pages/featured.jsx"
import AllProductsPage from "./pages/all-products.jsx"
import AllCategories from "./pages/all_categories.js";
import DoctorsPage from "./pages/alldoctors.jsx"
import ActiveTests from "./pages/active-test.jsx"
import AllTests from "./pages/all-tests.jsx"
import HealthMetricsPage from "./pages/all-metrics.js"; 
import MetricDetailPage from "./pages/metric-detail.jsx";
import HealthAssistant from "./pages/ashaCover.jsx";
import PhotoAnalysis from "./pages/photo-scan.jsx";
import UploadPrescription from "./pages/vision.jsx";
import TermsPolicyPage from "./pages/terms_policy.jsx";
import HealthDashboardSections from "./pages/healthdashboard.jsx";
import HealthTipsPage from "./pages/health-tips.jsx";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { NotificationProvider } from "./contexts/NotificationContext";
import { useNotifications } from "./contexts/NotificationContext";
import QuickActionCoverGate from "./components/QuickActionCoverGate";
import AllFeatures from "./pages/AllFeatures";
import { getRouteFromAppUrl, getRouteFromNotificationData } from "./lib/notificationRouting";
import BiometricUnlockGate from "./components/BiometricUnlockGate";
import NewAssessment from "./pages/assessment/new-assessment.tsx";
function InviteCaptureRedirect() {
  const { inviteCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!inviteCode) {
      navigate('/signup', { replace: true });
      return;
    }

    localStorage.setItem('pending_invite_code', inviteCode);
    navigate(`/signup?ref=${encodeURIComponent(inviteCode)}`, { replace: true });
  }, [inviteCode, navigate]);

  return null;
}

function NativeAppBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return undefined;
    }

    // Drain any tap that arrived before this component mounted (cold start scenario)
    const pending = consumePendingPushRoute();
    if (pending?.route) {
      navigate(pending.route, { replace: true });
    }

    const handleNativePushAction = (event) => {
      const route = event?.detail?.route;
      if (route) {
        navigate(route);
      }
    };

    window.addEventListener('qureo:nativePushAction', handleNativePushAction);

    const backButtonListener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
        return;
      }

      CapacitorApp.minimizeApp().catch(() => {
        // minimizeApp is Android-only. Ignore on unsupported platforms.
      });
    });

    const appUrlOpenListener = CapacitorApp.addListener('appUrlOpen', ({ url }) => {
      const routePath = getRouteFromAppUrl(url);
      if (routePath && routePath !== '/') {
        navigate(routePath);
      }
    });

    const pauseListener = CapacitorApp.addListener('pause', () => {
      console.log('App paused');
      window.dispatchEvent(new CustomEvent('qureo:appPaused'));
    });

    const resumeListener = CapacitorApp.addListener('resume', () => {
      console.log('App resumed');
    });

    return () => {
      window.removeEventListener('qureo:nativePushAction', handleNativePushAction);
      Promise.all([
        backButtonListener,
        appUrlOpenListener,
        pauseListener,
        resumeListener,
      ]).then((handles) => {
        handles.forEach((handle) => handle.remove());
      });
    };
  }, [navigate]);

  return null;
}

function App() {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  // Listen for messages in foreground
  useEffect(() => {
    onMessageListener().then((payload) => {
      const { title, body } = payload.notification || {};
      const { roomId, type } = payload.data || {};
      const actionRoute = getRouteFromNotificationData(payload.data || {});

      const isConsultation = type?.startsWith('consultation_');
      const isConsultationStart = type === 'consultation_started' || type === 'consultation_starting_soon';
      const isConsultationCall = isConsultationStart || type === 'consultation_30min';

      // Ring tone for consultation alerts - looping alarm pattern
      if (isConsultationCall) {
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          const ctx = new AudioCtx();
          const ringDuration = 2000; // total ring time
          const beepHigh = 880;
          const beepLow = 660;
          let elapsed = 0;

          const scheduleBeep = (startTime, freq, duration) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = 'sine';
            osc.frequency.setValueAtTime(freq, startTime);
            gain.gain.setValueAtTime(0.5, startTime);
            gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
            osc.start(startTime);
            osc.stop(startTime + duration);
          };

          while (elapsed < ringDuration) {
            const t = ctx.currentTime + elapsed / 1000;
            scheduleBeep(t, beepHigh, 0.3);
            scheduleBeep(t + 0.4, beepLow, 0.3);
            elapsed += 800;
          }
        } catch (audioErr) {
          // audio not available — ignore
        }
      }

      toast.info(
        <div className="text-left">
          <strong className="block text-lg font-semibold mb-1">{title}</strong>
          <p className="mb-2">{body}</p>
          {isConsultationCall && roomId && (
            <button
              onClick={() => (window.location.href = actionRoute)}
              className="mt-2 bg-blue-600 text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition"
            >
              Join Now
            </button>
          )}
        </div>,
        {
          position: 'top-right',
          autoClose: isConsultationCall ? false : 5000,
          theme: 'colored',
        }
      );
    });
  }, []);

  const stripePromise = loadStripe("pk_test_51SzVGyDBB0NuQQHl6VeyGaOTBydu4MuxDEfzUnqOlRzhUM3XdLp77F9dxZYOQbWZ3mVeFCJsS9LgFbIsLD60gexd00x3wIOARA");

  useEffect(() => {
    api.get("/"); // initial API test
  }, []);

  // 🔔 Request notification permission inside user click
  const handleEnableNotifications = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("user"));
      const ud = userId?._id;
      const token = await requestForToken(ud);
      console.log("FCM Token:", token);
      setNotificationsEnabled(true);
      toast.success("Notifications enabled!");
    } catch (err) {
      console.error("Notification permission denied", err);
      toast.error("Failed to enable notifications");
    }
  };

  return (
    <AuthProvider>
      <VitalsProvider>
      <NotificationProvider>
       <Router>
         <RouteAwareAppShell>
           <ScrollToTop />
           <NativeAppBridge />
          <BiometricUnlockGate />
          <AppSocketAdapter />
          <ToastContainer />
          {/* 
          {!notificationsEnabled && (
            <div style={{ padding: 10, textAlign: "center" }}>
              <button
                onClick={handleEnableNotifications}
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
              >
                Enable Notifications
              </button>
            </div>
          )}

          */}
 <Elements stripe={stripePromise}>
          <Routes>
         
            <Route path="/" element={<SplashShowcase />} />
            <Route path="/welcome" element={<WelcomeScreen />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/terms-policy" element={<TermsPolicyPage />} />
            <Route path="/invite/:inviteCode" element={<InviteCaptureRedirect />} />
            <Route path="/forgot-options" element={<ForgotPasswordOptions />} />
            <Route path="/forgot-reset" element={<ForgotPasswordReset />} />
            <Route path="/reset-confirmation" element={<PasswordResetConfirmation />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/health-assessment" element={<ProtectedRoute><NewAssessment /></ProtectedRoute>} />
            <Route path="/profile-setup" element={<ProtectedRoute><ProfileSetup /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/health-tips" element={<ProtectedRoute><HealthTipsPage /></ProtectedRoute>} />
            <Route path="/all-features" element={<AllFeatures />} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/profile/full" element={<ProtectedRoute><ProfileFull /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/health-journey-start" element={<ProtectedRoute><HealthJourneyStart /></ProtectedRoute>} />
            <Route path="/symptom-checker" element={<QuickActionCoverGate featureKey="symptom-checker"><SymptomChat /></QuickActionCoverGate>} />
            <Route path="/ai-chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
            <Route path="/chat-cover" element={<ProtectedRoute><CoverPage /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><NotificationPage /></ProtectedRoute>} />
            <Route path="/notification" element={<ProtectedRoute><NotificationPage /></ProtectedRoute>} />
            <Route path="/epharmacy" element={<QuickActionCoverGate featureKey="epharmacy"><EPharmacy /></QuickActionCoverGate>} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/category/:id" element={<Categories />} />
            <Route path="/cart" element={<ProtectedRoute><CartPage /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/prescription" element={<PrescriptionPage />} />
            <Route path="/all-pharmacies" element={<PharmacySearchPage />} />
            <Route path="/pharmacy/:id" element={<PharmacyDetailPage />} />
            <Route path="/doctor-consult" element={<QuickActionCoverGate featureKey="doctor-consult"><DoctorDirectory /></QuickActionCoverGate>} />
            <Route path="/booking-screen" element={<BookingScreen />} />
            <Route path="/booking-clinic" element={<InPersonBooking />} />
            <Route path="/clinic/:id" element={<ClinicDetail />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/live-consultation" element={<LiveConsultation />} />
            <Route path="/search-page" element={<SearchPage />} />
            <Route path="/specialist-page/:id" element={<SpecialistPage />} />
            <Route path="/doctor-details/:id" element={<DoctorDetails />} />
            <Route path="/appoint" element={<AppointmentTimeline />} />
            <Route path="/reschedule" element={<RescheduleSlotPage />} />
            <Route path="/cancel" element={<CancelAppointmentPage />} />
            <Route path="/appointment-card" element={<AppointmentCard />} />
            <Route path="/pre-join" element={<PreCallChecklist />} />
            <Route path="/call/:id" element={<PatientCallRoom />} />
            <Route path="/consultation" element={<VideoConsultation />} />
             <Route path="/consultation-chats" element={<ProtectedRoute><ConsultationChats /></ProtectedRoute>} />
             <Route path="/consultation-chats/:id" element={<ProtectedRoute><ConsultationChats /></ProtectedRoute>} />
             <Route path="/shared-records/:recordIds" element={<SharedRecordsViewer />} />
             <Route path="/mock-consultation" element={<MockConsultation />} />
            <Route path="/doctor-test" element={<DoctorCall />} />
            <Route path="/blogs" element={<QuickActionCoverGate featureKey="learn-health"><Blogs /></QuickActionCoverGate>} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/lab-tests" element={<ProtectedRoute><QuickActionCoverGate featureKey="lab-tests"><LabTest /></QuickActionCoverGate></ProtectedRoute>} />
            <Route path="/asha" element={<ProtectedRoute><HealthAssistantHero /></ProtectedRoute>} />
             <Route path="/lab-tests/:testId" element={<LabTestProfile />} />
            <Route path="/lab-cart" element={<LabCart />} />
            <Route path="/booking-details/:bookingId" element={<BookingDetails />} />
            <Route path="/lab-test-search" element={<LabTestSearch />} />
            <Route path="/all-providers" element={<AllProviders />} />
            <Route path="/providers/:id" element={<ProvidersDetailPage />} />
            <Route path="/my-health-records" element={<QuickActionCoverGate featureKey="my-health-records"><MyHealthRecords /></QuickActionCoverGate>} />
            <Route path="/health-wallet" element={<QuickActionCoverGate featureKey="health-wallet"><HealthWalletFullUI /></QuickActionCoverGate>} />
            <Route path="/wallet-transfer/:id" element={<WalletTransfer/>}/>
            <Route path="/scan/:id" element = {<Scan/>}/>
            <Route path="/generate" element = {<QrCodeGenerator/>} />
            <Route path="/remote" element = {<QuickActionCoverGate featureKey="remote"><Remote/></QuickActionCoverGate>}/>
            <Route path="/scan" element={<ScanMedicalPage />} />
            <Route path="/services" element={<NearbyServicesPage />} />
            <Route path="/campaigns" element={<QuickActionCoverGate featureKey="campaigns"><CampaignsPage /></QuickActionCoverGate>} />
            <Route path="/emergency-response" element = {<QuickActionCoverGate featureKey="emergency-response"><EmergencyResponseUI/></QuickActionCoverGate>}/>
            <Route path="/trending" element={<TrendingDrugs />} />
            <Route path="/featured" element={<FeaturedDrugs />} />
            <Route path="/all-products" element={<AllProductsPage />} />
            <Route path="/all-categories" element={<AllCategories />} />
            <Route path = "/all-doctors" element = {<DoctorsPage/>}/>
            <Route path = "/active-tests" element = {<ActiveTests/>}/>
            <Route path = "/all-tests" element = {<AllTests/>}/>
            <Route path = "/health-metrics" element = {<HealthMetricsPage/>}/>
            <Route path = "/metrics/:slug" element = {<MetricDetailPage/>}/>
            <Route path="/healthdashboard/*" element={<ProtectedRoute><HealthDashboardSections /></ProtectedRoute>} />
            <Route path="/asha-cover" element={<ProtectedRoute><HealthAssistant /></ProtectedRoute>} />
            <Route path="/photo-analysis" element={<ProtectedRoute><PhotoAnalysis /></ProtectedRoute>} />
            <Route path="/vision" element={<ProtectedRoute><UploadPrescription /></ProtectedRoute>} />
          </Routes>

          </Elements>
        </RouteAwareAppShell>
      </Router>
      </NotificationProvider>
      </VitalsProvider>
    </AuthProvider>
  );
}

function RouteAwareAppShell({ children }) {
  const location = useLocation();
  const noInsetRoutes = new Set(["/", "/welcome"]);
  const isSplashRoute = noInsetRoutes.has(location.pathname);

  return (
    <div className={`app-root ${isSplashRoute ? "app-root--no-system-offset" : "app-root--with-system-offset"}`}>
      {children}
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

// Handles socket events that need access to NotificationContext (must render inside providers)
function AppSocketAdapter() {
  const { addNotification } = useNotifications();

  useEffect(() => {
    const userRaw = localStorage.getItem("user");
    const userId = userRaw ? JSON.parse(userRaw)?._id : null;
    if (userId) socket.emit("joinRoom", userId);

    socket.on("consultationReminder", (data) => {
      const actionRoute = getRouteFromNotificationData({
        type: "consultation_reminder",
        roomId: data.consultation?.roomId,
      });

      // Ring device when consultation reminder received
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioCtx();
        const ringDuration = 2000;
        const beepHigh = 880;
        const beepLow = 660;
        let elapsed = 0;
        const scheduleBeep = (startTime, freq, duration) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.type = 'sine';
          osc.frequency.setValueAtTime(freq, startTime);
          gain.gain.setValueAtTime(0.5, startTime);
          gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
          osc.start(startTime);
          osc.stop(startTime + duration);
        };
        while (elapsed < ringDuration) {
          const t = ctx.currentTime + elapsed / 1000;
          scheduleBeep(t, beepHigh, 0.3);
          scheduleBeep(t + 0.4, beepLow, 0.3);
          elapsed += 800;
        }
      } catch (audioErr) {
        // audio not available — ignore
      }

      toast.info(
        <div className="text-left">
          <strong className="block text-lg font-semibold mb-1">
            Consultation Reminder
          </strong>
          <p className="mb-2">{data.message}</p>
          {data.consultation?.roomId && (
            <button
              onClick={() => (window.location.href = actionRoute)}
              className="mt-2 bg-blue-600 text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition"
            >
              Join Now
            </button>
          )}
        </div>,
        { position: "top-right", autoClose: false, theme: "colored" }
      );

      addNotification({
        type: "consultation_reminder",
        title: "Consultation Reminder",
        body: data.message || "Your consultation is starting soon",
        icon: "🩺",
        data: { roomId: data.consultation?.roomId },
      });
    });

    socket.on("orderDeliveryUpdate", (data) => {
      const statusLabels = {
        processing: 'Processing',
        shipped: 'Shipped',
        out_for_delivery: 'Out for Delivery',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
      };
      const label = statusLabels[data.status] || data.status || 'Updated';
      addNotification({
        type: 'order_delivery',
        title: 'Order Update',
        body: `Your order is now: ${label}`,
        icon: '🚚',
        data: { orderId: data.orderId, status: data.status },
      });
    });

    return () => {
      socket.off("consultationReminder");
      socket.off("orderDeliveryUpdate");
    };
  }, [addNotification]);

  return null;
}

export default App;
